import { useEffect, useState } from "react";
import { getBranches, getCostCenters, getProjects } from "../../../../Api/apiClient";
import { mapOptionName } from "../../../../utils/localizedText";

// name can arrive as an {ar, en} object; mapOptionName flattens it to plain
// strings (name/nameAr/nameEn) so it is always safe to render.
const toList = (raw) => {
  const list = Array.isArray(raw) ? raw : raw?.results || raw?.data;
  return Array.isArray(list) ? list.map((item) => mapOptionName(item)) : [];
};

// Module-level cache: the lists rarely change within a session, and the component
// unmounts whenever a non-performance report is selected.
let cachedOptions = null;
let pendingFetch = null;

const fetchDimensionOptions = () => {
  if (cachedOptions) return Promise.resolve(cachedOptions);
  if (pendingFetch) return pendingFetch;

  pendingFetch = Promise.allSettled([getBranches(), getProjects(), getCostCenters()]).then(
    ([branchesResult, projectsResult, costCentersResult]) => {
      const read = (result) => (result.status === "fulfilled" ? toList(result.value?.data) : []);
      cachedOptions = {
        branches: read(branchesResult),
        projects: read(projectsResult),
        costCenters: read(costCentersResult),
      };
      pendingFetch = null;
      return cachedOptions;
    }
  );

  return pendingFetch;
};

export const useDimensionFilters = () => {
  const [options, setOptions] = useState(
    cachedOptions || { branches: [], projects: [], costCenters: [] }
  );
  const [isLoading, setIsLoading] = useState(!cachedOptions);

  useEffect(() => {
    let ignore = false;

    fetchDimensionOptions().then((resolved) => {
      if (ignore) return;
      setOptions(resolved);
      setIsLoading(false);
    });

    return () => {
      ignore = true;
    };
  }, []);

  return { options, isLoading };
};
